<template>
  <div class="hzc-industry-dynamics">
    <div  class="back">当前位置：<span @click="back">动力煤</span> > 研究报告</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>研究报告</p>
        <div class="btn fr" @click="search">搜索</div>
        <input class="fr" type="text" v-model="likeFileTitle" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs(1)" :class="{'hover':flag === 1}">日报</div>
        <div @click="changeTabs(2)" :class="{'hover':flag === 2}">周报</div>
        <div @click="changeTabs(3)" :class="{'hover':flag === 3}">月报</div>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p @click="downloadReport(item)">{{ item.fileTitle }}</p>
          <span class="fr">{{ item.showYearTime }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;" @click="homePage">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="size"
          :current-page="page"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;" @click="lastPage">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  priceNoAuthList,
  stockNoAuthList,
  rateNoAuthList,
  industryNoAuthList,
  exitNoAuthList,
  reportDetail,
  reportList
} from '@/api/powerCoal'

export default {
  data() {
    return {
      list: [],
      page: 1,
      size: 15,
      likeFileTitle:'',
      total: 0,
      flag: 2
    }
  },
  created() {
    if (this.$route.query&&this.$route.query['flag']) {
      this.flag = Number(this.$route.query['flag']);
    }
    this.getList({pageNum: this.page, pageSize: this.size, fileType: this.flag, sourceType:3, likeFileTitle:this.likeFileTitle});
  },
  methods: {
    // 获取列表
    getList(pageParams) {
      reportList(pageParams).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    /**
     * 下载文件
     */
    downloadReport(row) {
      reportDetail(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['动力煤', '研究报告', '正文'], row['id']);
      })
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.flag = num;
      this.page = 1;
      this.getList({pageNum: this.page, pageSize: this.size, fileType: this.flag, sourceType:3, likeFileTitle:this.likeFileTitle});
    },
    /**
     * 前往详情页
     */
    goDetail(id) {
      this.$router.push({path:`/powerCoal/industry`, query:{id}})
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/powerCoal')
    },

    /**
     * 分页
     */
    changePage(page) {
      this.page = page;
      this.getList({pageNum: this.page, pageSize: this.size, fileType: this.flag, sourceType:3, likeFileTitle:this.likeFileTitle})
    },
    /**
     * 搜索
     */
    search() {
      this.page = 1;
      this.getList({pageNum: this.page, pageSize: this.size, fileType: this.flag, sourceType:3, likeFileTitle:this.likeFileTitle})
    },
    /**
     * 首页
     */
    homePage(){
      this.changePage(1)
    },
    /**
     * 末页
     */
    lastPage(){
      let cpage = Math.ceil(this.total / this.size);
      this.changePage(cpage)
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
